import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbDateInput } from "abreact/input/date/AbDateInput";
import { AbCalendarDay } from "abweb/utils/date/AbCalendarDay";
import * as React from "react";
// This matches AbDateInput behavior. But probably should use server config parameters customerDate.epoch and customerDate.horizon
// Turns out trying to save dates beyond epoch to horizon will restrict the date to that range. So we should have UI match.
// Override Kendo default min/max date, which default to 1900-01-01 & 2099-12-31
export const DEFAULT_FIELD_MIN_DATE = new Date(1000, 0);
export const DEFAULT_FIELD_MAX_DATE = new Date(9999, 11, 31);
export function AbDateDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-date-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  return !viewModel.isEditing ? currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", viewModel.readOnlyProps, props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    dataTestId: props.dataTestId,
    subject: props.subject,
    accessor: props.accessor,
    currentValue: props.currentValue
  })) : /*#__PURE__*/React.createElement(AbDateInput, _extends({}, viewModel.inputProps, {
    value: currentValue ?? undefined,
    onChange: viewModel.changeValue,
    latestDate: AbCalendarDay.fromLocalDate(props.latestDate ?? DEFAULT_FIELD_MAX_DATE),
    earliestDate: AbCalendarDay.fromLocalDate(props.earliestDate ?? DEFAULT_FIELD_MIN_DATE)
  }));
}
//# sourceMappingURL=AbDateDataValueInput.js.map
